import clsx from 'clsx';
import type { ComponentProps, ReactNode } from 'react';
import { useAppSelector } from 'rtk/query/hooks';
import type { THubertButtonSizes, THubertButtonVariants } from '../HubertButton';
import { HubertButton } from '../HubertButton';
import HubertDialog from '../HubertDialog';

type TConfirmationDialogActionButtons = {
  onClick: () => void;
  buttonText: string;
  variant?: THubertButtonVariants;
  size?: THubertButtonSizes;
};

interface Props extends ComponentProps<typeof HubertDialog> {
  isOpen?: boolean;
  title?: string;
  description?: string;
  content?: string | ReactNode;
  onCancel?: () => void;
  actionButtons?: TConfirmationDialogActionButtons[];
}

const HubertConfirmationDialog = ({
  isOpen,
  title,
  description,
  content,
  onCancel,
  actionButtons = [],
  ...props
}: Props) => {
  const dialog = useAppSelector((state) => state.Layout.confirmationDialog);
  const portalContainer = document.getElementById('main-content') as HTMLElement;

  return (
    <HubertDialog open={isOpen} overlay={true} modal={true} {...props}>
      <HubertDialog.Portal>
        <HubertDialog.Content
          title={title ?? (dialog && dialog.data && dialog.data.title)}
          description={description ? description : dialog && dialog.data && dialog.data.message}
          position="center"
          portalContent={true}
          portalElement={portalContainer}
        >
          {content}
          <div className={clsx('flex flex-row justify-between gap-4', 'mt-4')}>
            <div>
              <HubertButton
                variant={'secondary'}
                size={'sm'}
                onClick={() => {
                  if (onCancel) {
                    onCancel();
                  }
                }}
              >
                {(dialog && dialog.data && dialog.data.onCancel.buttonText) ?? 'Cancel'}
              </HubertButton>
            </div>

            <div className="flex flex-row gap-4">
              {actionButtons.map((btn, idx) => {
                return (
                  <HubertButton
                    key={`hubert-confirmation-dialog-action-button-${idx}`}
                    variant={btn.variant}
                    size={btn.size}
                    onClick={() => {
                      if (btn.onClick) {
                        btn.onClick();
                      }
                    }}
                  >
                    {btn.buttonText}
                  </HubertButton>
                );
              })}
            </div>
          </div>
        </HubertDialog.Content>
      </HubertDialog.Portal>
    </HubertDialog>
  );
};

export default HubertConfirmationDialog;
